module.exports = __webpack_public_path__ + "static/media/degree.2b7a8e4f.png";